import { render } from "./ProgressComponent.vue?vue&type=template&id=28f54183&scoped=true"
import script from "./ProgressComponent.vue?vue&type=script&lang=js"
export * from "./ProgressComponent.vue?vue&type=script&lang=js"

import "./ProgressComponent.vue?vue&type=style&index=0&id=28f54183&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f54183"]])

export default __exports__